import { createReducer, Action, on } from '@ngrx/store';

import { HomeActions } from './home.actions';
import { HomeState } from './home.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: HomeState = {};

const featureReducer = measureReducer(
  createReducer(
    initialState,

    on(HomeActions.LoadRecentActivities, (state): HomeState => ({ ...state, activityRecentSummary: undefined, error: undefined })),
    on(
      HomeActions.LoadRecentActivitiesSuccess,
      (state, action): HomeState => ({
        ...state,
        activityRecentSummary: action.activityRecentSummary,
      }),
    ),
    on(
      HomeActions.LoadRecentActivitiesFail,
      (state, action): HomeState => ({
        ...state,
        activityRecentSummary: undefined,
        error: action.error,
      }),
    ),
  ),
);

export function reducer(state: HomeState | undefined, action: Action) {
  return featureReducer(state, action);
}
